import { render, staticRenderFns } from "./volume-submit-success-dialog.vue?vue&type=template&id=374c249c&scoped=true"
import script from "./volume-submit-success-dialog.vue?vue&type=script&lang=js"
export * from "./volume-submit-success-dialog.vue?vue&type=script&lang=js"
import style0 from "./volume-submit-success-dialog.vue?vue&type=style&index=0&id=374c249c&prod&scoped=true&lang=css"
import style1 from "./volume-submit-success-dialog.vue?vue&type=style&index=1&id=374c249c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374c249c",
  null
  
)

export default component.exports